const Footer = () => (
  <footer className="footer">
    <div className="footer-social">
      {/* Instagram */}
      <a
        className="footer-icon"
        href="https://instagram.com/tearabytess"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
        width="70"
        height="70"
      >
        <path d="M 7.75 2 A 5.75 5.75 0 0 0 2 7.75 v 8.5 A 5.75 5.75 0 0 0 7.75 22 h 8.5 A 5.75 5.75 0 0 0 22 16.25 v -8.5 A 5.75 5.75 0 0 0 16.25 2 h -8.5 z m 0 1.5 h 8.5 A 4.25 4.25 0 0 1 20.5 7.75 v 8.5 a 4.25 4.25 0 0 1 -4.25 4.25 h -8.5 a 4.25 4.25 0 0 1 -4.25 -4.25 v -8.5 A 4.25 4.25 0 0 1 7.75 3.5 z M 15.75 5.5 a 0.75 0.75 0 1 0 0 1.5 a 0.75 0.75 0 0 0 0 -1.5 Z m -3.75 2 a 4.75 4.75 0 1 0 0 9.5 A 4.75 4.75 0 0 0 12 7.5 z m 0 1.5 a 3.25 3.25 0 1 1 0 6.5 a 3.25 3.25 0 0 1 0 -6.5 z"/>
      </svg>

      </a>
      {/* LinkedIn */}
      <a
        className="footer-icon"
        href="https://linkedin.com/company/tearabyte-software-solutions"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="LinkedIn"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 448 512"
          width="60"
          height="60"
        >
          <path d="M100.28 448H7.4V148.9h92.88zm-46.44-340.6C24.08 107.4 0 83.32 0 53.78 0 24.23 24.08 0 53.84 0s53.83 24.23 53.83 53.78c0 29.54-24.07 53.82-53.83 53.82zM447.9 448h-92.68V302.4c0-34.7-.7-79.3-48.3-79.3-48.3 0-55.7 37.8-55.7 76.8V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.6 42.5-48.3 87.5-48.3 93.6 0 110.9 61.6 110.9 141.7V448z"/>
        </svg>
      </a>
    </div>
    <div className="footer-copy">
      © {new Date().getFullYear()} Tearabyte Software Solutions
    </div>
  </footer>
);

export default Footer;
